// extracted by mini-css-extract-plugin
export default {"list":"GroupPerformanceGraph_list__PruL7"};